<div id="error-404" fxLayout="column" fxLayoutAlign="center center">

    <div class="content" fxLayout="column" fxLayoutAlign="center center">

        <div class="error-code">404</div>

        <div class="message">Sorry but we could not find the page you are looking for</div>

        <div class="search" fxLayout="row" fxLayoutAlign="start center">
            <mat-icon class="icon s-24">search</mat-icon>
            <input placeholder="Search for something" fxFlex>
        </div>

        <a class="back-link" [routerLink]="'/apps/dashboards/project'">Go back to dashboard</a>

    </div>

</div>